import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initThemeSystem } from "./lib/theme";

// Honor the saved theme on every launch + follow OS changes when in "system" mode.
initThemeSystem();

createRoot(document.getElementById("root")!).render(<App />);
